import React, { FC } from "react";
import OnboardingAccountForm from "@components/Onboarding/OnboardingAccountForm/OnboardingAccountForm";

const Account: FC = () => {
  return <OnboardingAccountForm />;
};

export default Account;
